module.exports = __webpack_public_path__ + "img/1.9841a36b.png";